import React from "react";
import { formatMoney } from "helpers/policy";
import {Row, Col} from 'reactstrap'
/**
 * @typedef {Object} paymentFormValues
 * @property {String=} paymentFormValues.policyNumber
 * @property {String=} paymentFormValues.paymentAmount
 * @property {String=} paymentFormValues.paymentPurpose
 * @property {String=} paymentFormValues.paymentPurposeDetailed
 * @property {String=} paymentFormValues.currencyType
 * @property {Boolean=} paymentFormValues.fromRenewalFlow
 * @property {Object=} paymentFormValues.codes
 * @property {Object=} paymentFormValues.premiumPA_UM
 * @property {Object=} paymentFormValues.extensions
 */

/**
 * @typedef {Object} billingFormValues
 * @property {String=} billingFormValues.firstName
 * @property {String=} billingFormValues.lastName
 * @property {String=} billingFormValues.email
 * @property {String=} billingFormValues.phoneNumber
 * @property {String=} billingFormValues.billingAddress
 * @property {String=} billingFormValues.country
 * @property {String=} billingFormValues.region
 * @property {String=} billingFormValues.zip_code
 * @property {String=} billingFormValues.cardNumber
 * @property {String=} billingFormValues.cardName
 * @property {String=} billingFormValues.cardExpiryMonth
 * @property {String=} billingFormValues.cardExpiryYear
 * @property {String=} billingFormValues.cardCVC
 */

/**
 * Shows the Payment Details
 * @param {Object} props
 * @param {paymentFormValues} props.paymentDetails
 * @param {{session: *, sourceOfFunds: *}} props.paymentResponse
 * @param {(value: String) => void} props.maskCreditCard
 * @param {billingFormValues} props.billingDetails
 * @param {boolean} props.reWrite
 */
const PaymentContent = ({ paymentDetails, paymentResponse, maskCreditCard, billingDetails, reWrite }) => (
	<div style={{margin: "0 10px"}}>
		<div 
			style={{
				background: "rgb(249 250 251)",
				borderRadius: 10,
				padding: "10px 20px"
			}}
		> 
			<div style={{ display: "flex", gap: 5, justifyContent: "space-between", alignItems: "flex-end", borderBottom: "0.125px solid gray"}}>
				<span style={{lineHeight: "36px"}}>Total Amount</span>
				<span style={{fontSize: 12, fontWeight: "600"}}>{paymentDetails.currencyType}<strong style={{fontSize: 30, color: "black", marginLeft: 5}}>{`${formatMoney(paymentDetails.paymentAmount)}`}</strong></span>
			</div>
			<div style={{padding: "20px 0"}}> 
				<div style={{ marginBottom: 10, display: "flex", gap: 5, justifyContent: "space-between", alignItems: "flex-end"}}>
					<span>Policy No.</span>
					<span style={{color: "#1c1c1c"}}>{reWrite ? "T.B.A" : paymentDetails.policyNumber}</span>
				</div>
				<div style={{ marginBottom: 10, display: "flex", gap: 5, justifyContent: "space-between", alignItems: "flex-end"}}>
					<span>{"Transaction Type"}</span>
					<span style={{color: "#1c1c1c"}}>
						{paymentDetails.paymentPurpose === "Other"
						? `Other - ${paymentDetails.paymentPurposeDetailed}`
						: reWrite ? "Policy Rewrite"
						: paymentDetails.paymentPurpose}
					</span >
				</div>
				<div style={{ marginBottom: 10, display: "flex", gap: 5, justifyContent: "space-between", alignItems: "flex-end"}}>
					<span>Payment Method</span>
					<span style={{color: "#1c1c1c"}}>
						<span style={{margin: "0 10px"}}>
							<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M15.5068 6.67299C15.5068 6.67299 15.7575 7.91853 15.8135 8.17969H14.7118C14.8207 7.8817 15.2396 6.72321 15.2396 6.72321C15.233 6.73326 15.3484 6.41853 15.4144 6.22433L15.5068 6.67299ZM19 1.60714V13.3929C19 14.2801 18.2908 15 17.4167 15H1.58333C0.709201 15 0 14.2801 0 13.3929V1.60714C0 0.719866 0.709201 0 1.58333 0H17.4167C18.2908 0 19 0.719866 19 1.60714ZM5.03038 10.0179L7.1151 4.82143H5.71319L4.41684 8.37054L4.275 7.65067L3.81319 5.26004C3.73733 4.92857 3.50313 4.83482 3.21285 4.82143H1.07865L1.05556 4.92522C1.57674 5.05915 2.04184 5.25335 2.44757 5.49777L3.62847 10.0179H5.03038ZM8.14427 10.0246L8.97552 4.82143H7.64948L6.82153 10.0246H8.14427ZM12.759 8.32366C12.7656 7.73103 12.4094 7.27902 11.6474 6.90737C11.1823 6.66964 10.8986 6.50893 10.8986 6.26451C10.9052 6.04353 11.1394 5.81585 11.6606 5.81585C12.0927 5.8058 12.4094 5.9096 12.6469 6.01339L12.7656 6.07031L12.947 4.94531C12.6865 4.84152 12.2708 4.72433 11.7595 4.72433C10.45 4.72433 9.52969 5.43415 9.52309 6.44531C9.5132 7.19196 10.1828 7.60714 10.6842 7.85826C11.1955 8.11272 11.3703 8.28013 11.3703 8.50446C11.3637 8.85268 10.9547 9.01339 10.5753 9.01339C10.0476 9.01339 9.76389 8.92969 9.33177 8.73549L9.15694 8.65179L8.97222 9.82031C9.28229 9.96428 9.85625 10.0915 10.45 10.0982C11.842 10.1016 12.7491 9.40179 12.759 8.32366ZM17.4167 10.0246L16.3479 4.82143H15.322C15.0054 4.82143 14.7646 4.91518 14.6293 5.25335L12.6601 10.0246H14.0521C14.0521 10.0246 14.2797 9.3817 14.3292 9.24442H16.0313C16.0708 9.42857 16.1896 10.0246 16.1896 10.0246H17.4167Z" fill="#999999"/>
							</svg>
						</span>
						{paymentResponse && maskCreditCard(paymentResponse.sourceOfFunds.provided.card.number)}
					
					</span>
				</div>
				<div style={{ marginBottom: 10, display: "flex", gap: 5, justifyContent: "space-between", alignItems: "flex-end"}}>
					<span>Card Holder</span>
					<span style={{color: "#1c1c1c"}}>{billingDetails.cardName}</span>
				</div>
				
			</div>
		
		</div>
		<div
			style={{
				width: "100%",
				display: "flex",
				alignItems: "flex-start",
				gap: 10,
				padding: "12px 14px",
				borderRadius: 10,
				border: "1px solid #bfdbfe", 
				background: "#eff6ff",
				boxSizing: "border-box",
				margin: "20px 0 0 0"
			}}
			>
			<div
				style={{
				width: 20,
				height: 20,
				flex: "0 0 auto",
				color: "#2563eb",
				marginTop: 1,
				}}
				aria-hidden="true"
			>
				
				<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M7 0C7.13417 0 7.26833 0.029458 7.39083 0.0854281L12.8829 2.43912C13.5246 2.71308 14.0029 3.35232 14 4.12412C13.9854 7.04635 12.7954 12.393 7.77 14.8233C7.28292 15.0589 6.71708 15.0589 6.23 14.8233C1.20459 12.393 0.0145966 7.04635 1.32664e-05 4.12412C-0.00290339 3.35232 0.475429 2.71308 1.11709 2.43912L6.61208 0.0854281C6.73167 0.029458 6.86583 0 7 0ZM7 1.96779V13.1029C11.025 11.1351 12.1071 6.77828 12.1333 4.16536L7 1.96779Z" fill="#2563EB"/>
				</svg>

			</div>

			<div
				style={{
				color: "#2563eb",
				fontSize: 13,
				fontWeight: 300,
				lineHeight: 1.35,
				textAlign: "left"
				}}
			>
				This transaction is secure and encrypted. By clicking <b>Accept</b>, you authorize
				the payment of the amount shown above.
			</div>
		</div>
	</div>
);

export default PaymentContent;
